/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [根据中分位id获取中分位↗](http://yapi.yishou.com/project/128/interface/api/33638) 的 **请求配置**
 *
 * @分类 [开发波次单越库限制条件↗](http://yapi.yishou.com/project/128/interface/api/cat_3200)
 * @请求头 `POST /erp/HalveGroup/getHgCodeByHgId`
 * @更新时间 `2022-06-13 16:48:37`
 */
const getHgCodeByHgIdRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/HalveGroup/getHgCodeByHgId",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["hg_id"],
        properties: { hg_id: { type: "string", description: "中分位分组id" } },
    },
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: {
                hg_code: { type: "string", description: "中分位编号" },
                hgd_id: { type: "string", description: "中分位id" },
            },
            required: ["hg_code", "hgd_id"],
        },
    },
    requestFunctionName: "getHgCodeByHgId",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [根据中分位id获取中分位↗](http://yapi.yishou.com/project/128/interface/api/33638) 的 **请求函数**
 *
 * @分类 [开发波次单越库限制条件↗](http://yapi.yishou.com/project/128/interface/api/cat_3200)
 * @请求头 `POST /erp/HalveGroup/getHgCodeByHgId`
 * @更新时间 `2022-06-13 16:48:37`
 */
export const getHgCodeByHgId = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getHgCodeByHgIdRequestConfig, requestData), ...args);
};
getHgCodeByHgId.requestConfig = getHgCodeByHgIdRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/halveGroup.js